import { registerIcon } from "@ui5/webcomponents-base/dist/SVGIconRegistry.js";

const name = "accept";
const pathData = "M455.8 94q9 9 3 19l-222 326q-4 8-12 9t-14-5l-151-167q-5-5-4.5-11t5.5-11l25-25q12-12 23 0l96 96q5 5 13 4.5t12-8.5l175-249q4-7 11.5-8t13.5 4z";
const ltr = true;
const collection = "SAP-icons";

registerIcon(name, { pathData, ltr, collection});

export default { pathData };